<script lang="ts">
  import CategoryBreadcrumbs from '$lib/components/category/CategoryBreadcrumbs.svelte'
  import Subcategories from '$lib/components/category/Subcategories.svelte'
  import { getUniverseInfo } from '$lib/js/helpers'
  import { page } from '$app/stores'

  export let category: { name: string, url_path: string }

  $: universe_info = getUniverseInfo(
    $page.data?.universes_menu?.universes,
    category.url_path.split('/')[1],
  )
</script>


<div class="category-banner">
  <div class="category-banner__inner">
    <div class="category-banner__bg">
      <img
        src="/images/bg-grey.jpg"
        title="{universe_info?.description}"
        alt="{universe_info?.description}"
        width=1440
        height=589
      />
      {#if universe_info}
        <div class="category-banner__shadow" style="background: {universe_info.color}"></div>
      {/if}
    </div>
    <div class="category-banner__content">
      <div class="container">
        <div class="category-banner__content__inner">
          <CategoryBreadcrumbs breadcrumbs={$page.data.breadcrumbs}/>

          {#if $page.params.brand_url}
            <h1 class="head-2">{category.name} {$page.data.brand?.page_title}</h1>
          {:else}
            <h1 class="head-2">{category.name}</h1>
          {/if}

          {#if $page.route.id === "/[lang]/c/[...cat_url]"}
            <Subcategories />
          {/if}
        </div>
      </div>
    </div>
  </div>
</div>


<style lang="scss">
  .category-banner {
    position: relative;
    overflow: hidden;

    &__bg {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &__shadow {
      mix-blend-mode: color;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }

    &__content {
      position: relative;

      &__inner {
        min-height: auto;
        padding: 25px 0 30px;

        h1, p {
          color: black;
          line-height: 1.2;

          span {
            margin-top: 5px;
            display: inline-block;
            margin-left: 10px;
            font-size: 16px;
            font-weight: 400;
          }
        }

        h1 {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
        }
      }
    }
  }
</style>
